import { ChevronDown } from 'lucide-react'
import { useEffect, useRef, type ReactNode } from 'react'

/** Secondary controls and guidance, available without filling the whole page. */
export function SettingsDisclosure({ title, children, forceOpen = false }: {
  title: string
  children: ReactNode
  forceOpen?: boolean
}) {
  const details = useRef<HTMLDetailsElement>(null)
  useEffect(() => {
    if (forceOpen && details.current) details.current.open = true
  }, [forceOpen])

  return (
    <details ref={details} className="group rounded-lg border border-border px-3">
      <summary className="flex min-h-11 cursor-pointer list-none items-center justify-between gap-3 text-sm font-medium text-text [&::-webkit-details-marker]:hidden">
        {title}
        <ChevronDown className="h-4 w-4 shrink-0 text-text-muted transition-transform group-open:rotate-180" aria-hidden="true" />
      </summary>
      <div className="pb-3 pt-1">{children}</div>
    </details>
  )
}
